var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    className: "cls-1",
    d: "M12,2.87C6.64,2.87,2.3,7.21,2.3,12.57s4.34,9.7,9.7,9.7,9.7-4.34,9.7-9.7h0c0-5.36-4.34-9.7-9.7-9.7M12,6.75c.71,0,1.29.59,1.29,1.3s-.59,1.29-1.3,1.29c-.71,0-1.29-.58-1.29-1.29,0-.71.58-1.29,1.29-1.29,0,0,0,0,0,0M13.94,18.38h-3.88c-.36,0-.65-.29-.65-.65s.29-.65.65-.65h.64v-5.17h-.64c-.36,0-.65-.29-.65-.65s.29-.65.65-.65h2.59c.36,0,.65.29.65.65h0v5.82h.65c.36,0,.65.29.65.65s-.29.65-.65.65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/Resources.6850e71b6789948f7606c1bc609466f5.svg";
export { ForwardRef as ReactComponent };